import React,{useEffect} from 'react';
import Overlay from '../Overlay'
import styled from "styled-components"
// import closePopup from '../../../../assets/imgs/icons/cross-black.svg';
import logoutApi from './LogoutApi';
import Axios from 'axios';
import {wrapperEndPoint} from "../../../Utils/Api";


const SessionTimeoutHandler = (props) => {
    
    if(props.logoutUser){
        callLogoutApi('logout', true);
        return null;
    }

    function callLogoutApi(type,justApi = false){
        logoutApi(type, props.isPushBotVisible).then(function(msg){
            !justApi && props.toggleSessionTimeoutPopUp();
            if(type==='logout' || type==='sessionTimeout'){
                props.resetLogin();
            }
            var data = {
                "EntityName": "GenericQn: Hi, how can I help you today",
                "GenericResponse": true,
                "intentName": null,
                "intentID": null,
                "disamb": [],
                "entityID": null,
                "TimeStamp": "2019-04-15 14:28:56.888",
                "disambflag": false,
                "answer": msg,
                "extra": [],
                "promptLogin": false,
                "promptLogout": false,
                "isFeedbackVisible" : false,
                "WorkFlowflag": false,
                "nodeID": null,
                "key": '',
                "NonComprehendFlag": false,
                "errorFallbackLinks": "false"
            }
            if(type === 'keep-alive'){
                data.isLoggedIn = true;
                data.keepAlive = true;

            //Below is the sample URL for Keepalive request-

             if(props.netbanking){

                let data_SS0 =`bwayparam=${props.bwayparamSSO}&uniqueid=${props.uniqueidSSO}`

                console.log("KeepAlive, isLoggedIn-True");

                    Axios.post(wrapperEndPoint.keepAliveURL+props.uniqueidSSO, data_SS0)
                    .then(response => {
                        console.log(response);//handle sucess
                    }).catch(error => {
                        console.log(error);//handle error
                    });
             }
                 
            }
            props.addServerResponse(data);
        });
    }


    var timeout;
    useEffect(()=>{
        timeout = setTimeout(function() {

            if(props.isCrestDebitCardFlow){

               // console.log(props.isCrestDebitCardFlow);
                props.crestAbortedJourney();

            }
            
            setTimeout(() => {

                callLogoutApi('sessionTimeout');
                
            }, 1000);
            


        },60000);//60000 //1 min extention

        return ()=>{
            clearTimeout(timeout);
        }
    },[])
    function callresetSession(){
        console.log("resetSessionvar !!")
        window["resetSessionVar"]()
        // let data_SS0 = {bwayparam: this.state.bwayparamSSO ,uniqueID:this.state.uniqueidSSO}

        // console.log("KeepAlive, isLoggedIn-True");

        //     Axios.post(wrapperEndPoint.keepAliveURL+this.state.uniqueidSSO, JSON.stringify(data_SS0))
        //     .then(response => {
        //         console.log(response);//handle sucess
        //     }).catch(error => {
        //         console.log(error);//handle error
        //     });
    }
    return (

         <div>{!props.netbanking?

        <PopUpOverlay>
            <PopUpContent>
                {/* <img className="cross" onClick={()=>props.toggleSessionTimeoutPopUp()} src={closePopup} alt="close popup"/> */}
                <div className="title">
                    Session Expiration
                </div>
                <div className="desc">
                    Oh no! Your session is about to expire.
                    {/* Because you have been inactive, your session is about to expire */}
                </div>
                <Button primary type="text" onClick={()=>{callLogoutApi('keep-alive')}}>Stay Logged In</Button>
                <Button type="text" id="log-out" onClick={()=>{callLogoutApi('logout')}}>Log Out Now</Button>
            </PopUpContent>
       
        </PopUpOverlay>

        :
        (callresetSession(),
        callLogoutApi('keep-alive'))}</div>

        );
};

const PopUpOverlay = styled(Overlay)`
    top : 0;
    background : rgba(0,0,0,0.41);
    height: 100%;
    display : flex;
    justify-content : center;
    align-items : center;
`
const PopUpContent = styled.div`
    background : white;
    padding: 20px;
    padding-top : 35px;
    width : 80%;
    text-align : center;
    position : relative;
    border-radius : 5px;

    .cross {
        position: absolute;
        top: 15px;
        right: 25px;
        cursor: pointer;
    }

    .title{
        font-size: 18px;
        font-weight: 500;
        color: #2c387a;
    }

    .desc{
        margin : 10px 0 20px 0;
    }
`

const Button = styled.button`
    border: 0;
    color: white;
    height: 40px;
    display: block;
    font-size: 14px;
    border-radius: 20px;
    padding: 0 10px;
    width: 100%;
    box-shadow : none;
    outline : 0;
    margin: 15px 0;
    color : ${props=>{
        return props.primary ? '#fff' : '#2c387a'
    }};
    background : ${props=>{
        return props.primary ? '#2c387a' : '#fff'
    }};
    border : ${props=>!props.primary && '1px solid #2c387a'};
    cursor: pointer;
`

export default SessionTimeoutHandler;


